export default
  [
    {
      path: '',
      redirect: 'cargoOwnerManagement'
    },
    // 货主管理
    {
      path: 'cargoOwnerManagement',
      name: 'consignorCenter/cargoOwnerManagement',
      component: () => import('@/page/consignorCenter/cargoOwnerManagement'),
      meta: { openKeyName: '货主管理', selectKeyUrl: 'cargoOwnerManagement' }
    },
    {
      path: 'cargoOwnerManagement/:id',
      name: 'consignorCenter/consignorAuditDetail',
      component: () => import('@/page/consignorCenter/cargoOwnerManagementDetail'),
      meta: { openKeyName: '货主管理', selectKeyUrl: 'cargoOwnerManagement' },
      props: true
    },
    // 已认证货主
    {
      path: 'certificationCargoOwner',
      props: true,
      name: 'consignorCenter/certificationCargoOwner',
      component: () => import('@/page/consignorCenter/certificationCargoOwner'),
      meta: { openKeyName: '货主管理', selectKeyUrl: 'certificationCargoOwner' }
    },
    {
      path: 'certificationCargoOwner/:saleid',
      props: true,
      name: 'consignorCenter/certificationCargoOwner',
      component: () => import('@/page/consignorCenter/certificationCargoOwner'),
      meta: { openKeyName: '货主管理', selectKeyUrl: 'certificationCargoOwner' }
    },
    {
      path: 'certificationCargoOwnerDetail/:id',
      name: 'consignorCenter/certificationCargoOwnerDetail',
      component: () => import('@/page/consignorCenter/certificationCargoOwnerDetail'),
      meta: { openKeyName: '货主管理', selectKeyUrl: 'certificationCargoOwner' },
      props: true
    },
  ]



// WEBPACK FOOTER //
// ./src/router/consignorCenter/index.js